import React from "react"
import styled, { css } from "styled-components"
import { theme } from "../../../theme"
import { Alert as AlertMaterial } from "@mui/material"

export interface AlertProps {}

const AlertStyle = css`
  border-radius: ${theme.borderRadius};
  margin-bottom: ${theme.spacing.xl};
  box-shadow: ${theme.mui.shadows[3]};
  display: flex;
  align-items: center;
`

export const Alert = styled(AlertMaterial)`
  ${AlertStyle}
`

export const AlertWithShadow = styled(Alert)``
